import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ spacing: { unit } }: ComposedTheme) => ({
  buttonsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1.5 * unit,
    padding: [0, 20],
    '& .btn': {
      marginLeft: 0
    }
  }
});

export default createUseStyles(styles);
